import Vue from 'vue'
import Router from 'vue-router'
import ApiChildHandler from './components/ApiChildHandler.vue'
import Unvocalized from './views/Unvocalized.vue'
import Home from './views/Home.vue'
import { StoreConfig } from './store/storeConfig'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: StoreConfig.SERVER_ROOT + '/*',
      name: 'api-child-handler',
      component: ApiChildHandler
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },    
    {
      path: '/unvocalized',
      name: 'unvocalized',
      component: Unvocalized
    },
    {
      path: '/*',
      redirect: '/',
    }    
  ]
})


export default router
